import React, { useState } from "react";

const CustomItemModal = ({ isOpen, onClose, onSave }) => {
    const [formData, setFormData] = useState({ item_name: "", price: "" });
    const [errors, setErrors] = useState({});

    const handleNameChange = (e) => {
        setFormData(prev => ({ ...prev, item_name: e.target.value }));
    };

    const handlePriceChange = (e) => {
        const value = e.target.value;
        if (/^\d*\.?\d{0,2}$/.test(value)) {
            setFormData(prev => ({ ...prev, price: value }));
        }
    };

    const increasePrice = () => {
        setFormData(prev => ({ ...prev, price: Number(prev.price || 0) + 1 }));
    };

    const decreasePrice = () => {
        setFormData(prev => ({ ...prev, price: Math.max(0, Number(prev.price || 0) - 1) }));
    };

    const handleSubmit = () => {
        const tempErrors = {};

        if (!formData.item_name.trim()) tempErrors.item_name = "Item name is required";
        if (!formData.price) tempErrors.price = "Price is required";

        setErrors(tempErrors);

        if (Object.keys(tempErrors).length > 0) return;

        onSave(formData);
        setFormData({ item_name: "", price: "" });
        setErrors({});
    };

    if (!isOpen) return null;

    return (
        <div className="modal modalStyle fade show" style={{ display: "block", background: "rgba(0,0,0,.5)" }} tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">

                    <div className="modal-header">
                        <h1 className="modal-title mdTitle">Add Custom Item</h1>
                        <button type="button" className="btn-close" onClick={onClose} />
                    </div>

                    <div className="modal-body">
                        <div className="modalBodyStyle formStyle">

                            <div className="mb-3">
                                <input
                                    type="text"
                                    className={`form-control ${errors.item_name ? "is-invalid" : ""}`}
                                    placeholder="Item Name"
                                    value={formData.item_name}
                                    onChange={handleNameChange}
                                />
                                {errors.item_name && (
                                    <div className="invalid-feedback">{errors.item_name}</div>
                                )}
                            </div>

                            <div className="mb-3">
                                <label className="mb-2">Price</label>

                                <div className="input-group">
                                    <button type="button" className="btn btnLight" onClick={decreasePrice}>
                                        -
                                    </button>

                                    <input
                                        type="text"
                                        className={`form-control text-center ${errors.price ? "is-invalid" : ""}`}
                                        placeholder="Enter price"
                                        value={formData.price}
                                        onChange={handlePriceChange}
                                    />

                                    <button type="button" className="btn btnLight" onClick={increasePrice}>
                                        +
                                    </button>
                                </div>

                                {errors.price && (
                                    <div className="text-danger mt-1">{errors.price}</div>
                                )}
                            </div>

                        </div>
                    </div>

                    <div className="modal-footer justify-content-between">
                        <button type="button" className="btn btnLight" onClick={onClose}>
                            Close
                        </button>

                        <button type="button" className="btn btnPrimary" onClick={handleSubmit}>
                            Add Item
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default CustomItemModal;